import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formActions: [
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Nyomtatás',
                event_name: "customClick",
                class: "btn btn-info my-custom-class mx-1",
                event_payload: 'print'
            }
        ],
        formFields: [
            {
                name: "id",
                label: "ID",
                formVisible: false
            },
            {
                name: "patientId",
                label: "Páciens ID",
                formVisible: false
            },
            {
                name: "education",
                label: "Iskolai végzettség",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "qualification",
                label: "Szakmai végzettség",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "driverLicense",
                label: "Jogosítvány",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "driverLicenseNumber",
                label: "Jogosítvány száma",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "soldierly",
                label: "Katonaság",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "company",
                label: "Cég",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "companySite",
                label: "Telephely",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "job",
                label: "Munkakör",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "smokingId",
                label: "Dohányzik",
                formSize: 2,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getYesNoCodeStore,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "smokingTime",
                label: "Ideje (év)",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "smokingQuantity",
                label: "Menny. (szál)",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                rowBreak: true,
                formSize: 6,
                formVisible: true
            },
            {
                name: "alcoholId",
                label: "Alkoholt fogyaszt",
                formSize: 2,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getYesNoCodeStore,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "alcoholTime",
                label: "Ideje (év)",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "alcoholType",
                label: "Fajtája",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "alcoholQuantity",
                label: "Mennyiség",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                rowBreak: true,
                formSize: 4,
                formVisible: true
            },
            {
                name: "coffeeId",
                label: "Kávézik",
                formSize: 2,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getYesNoCodeStore,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "coffeeTime",
                label: "Ideje (év)",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                name: "coffeeQuantity",
                label: "Mennyiség",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                rowBreak: true,
                formSize: 6,
                formVisible: true
            },
            {
                name: "sportId",
                label: "Sportolás",
                formSize: 2,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getYesNoCodeStore,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "sportTime",
                label: "Ideje (év)",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                rowBreak: true,
                formSize: 8,
                formVisible: true
            },
            {
                name: "eatingHabit",
                label: "Étkezési szokás",
                formSize: 3,
                formVisible: true,
                formType: "text"
            },
            {
                name: "eatingTime",
                label: "Ideje (év)",
                formVisible: true,
                formSize: 2,
                formType: "text"
            },
            {
                rowBreak: true,
                formSize: 7,
                formVisible: true
            },
            {
                name: "fatherHeartSystem",
                label: "Apa szív-érrendszeri",
                formVisible: true,
                formSize: 3,
                formType: "checkbox",
            },
            {
                name: "fatherRespiratory",
                label: "Apa légzőszervi",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "fatherTumor",
                label: "Apa daganat",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "fatherDigestiveOrgans",
                label: "Apa emésztőszervi",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "fatherMetabolism",
                label: "Apa anyagcsere",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "fatherPsychology",
                label: "Apa pszich.",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "fatherDeath",
                label: "Apa halál",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "fatherOther",
                label: "Apa egyéb",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherHeartSystem",
                label: "Anya szív-érrendszeri",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherRespiratory",
                label: "Anya légzőszervi",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherTumor",
                label: "Anya daganat",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherDigestiveOrgans",
                label: "Anya emésztőszervi",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherMetabolism",
                label: "Anya anyagcsere",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherPsychology",
                label: "Anya pszich.",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherDeath",
                label: "Anya halál",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "motherOther",
                label: "Anya egyéb",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherHeartSystem",
                label: "Testvér szív-érrendszeri",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherRespiratory",
                label: "Testvér légzőszervi",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherTumor",
                label: "Testvér daganat",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherDigestiveOrgans",
                label: "Testvér emésztőszervi",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherMetabolism",
                label: "Testvér anyagcsere",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherPsychology",
                label: "Testvér pszich.",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherDeath",
                label: "Testvér halál",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "brotherOther",
                label: "Testvér egyéb",
                formVisible: true,
                formSize: 3,
                formType: "checkbox"
            },
            {
                name: "benzeneAndItsCompounds",
                label: "Benzol és egyéb vegyületei",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "aniline",
                label: "Anilin",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "otherAminoCompoundsOfBenzene",
                label: "Benzol egyéb aminovegyületei",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "digitalGlycosides",
                label: "Digitális glikozidok",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "dimethylFormahid",
                label: "Dimetil-formahid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "dioxane",
                label: "Dioxán (dietilén-dioxid)",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "ethylbenzene",
                label: "Etil-benzol",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "ethyleneOxide",
                label: "Etilén-oxid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "nHexane",
                label: "N-hexán",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "mercury",
                label: "Higany",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "halothane",
                label: "Halothán",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "isocyanate",
                label: "Izocianát",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "cadmiumAndItsCompounds",
                label: "Kadmium és vegyületei",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "cobalt",
                label: "Kobalt",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "chromiumCompounds",
                label: "Krómvegyületek",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "manganese",
                label: "Mangán",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "methylBromide",
                label: "Metil-bromid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "methylChloride",
                label: "Metil-klorid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "sodiumAndAluminumFluoride",
                label: "Nátrium-alimínium-fluorid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "nickel",
                label: "Nikkel",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "nitricOxide",
                label: "Nitrogén-oxidul (dinitrogén-oxid)",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "plantProtectantSpray",
                label: "Növényvédőszerek",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "leadAndCompounds",
                label: "Ólom és vegyületei",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "selenium",
                label: "Szelén",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "carcinogens",
                label: "Rákkeltő anyagok",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "carbonDisulfide",
                label: "Szén-diszulfid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "carbonMonoxide",
                label: "Szén-monoxid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "carbonTetrachloride",
                label: "Szén-tetraklorid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "styrene",
                label: "Sztirol",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "tetrachloroethane",
                label: "Tetraklór-etán",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "pushing",
                label: "Toloul",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "trichlorethylene",
                label: "Triklór-etilén",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "trinitroToloul",
                label: "Trinitro-toloul (trotyl)",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "powdersCausingLungFibrosis",
                label: "Tüdőfibrózist okozó porok",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "vanadium",
                label: "Vanádium",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "vinylChloride",
                label: "Vinil-klorid",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "xylene",
                label: "Xilol",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "noise",
                label: "Zaj",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "localVibration",
                label: "Helyi vibráció",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "wholeBodyVibration",
                label: "Egésztest vibráció",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "overpressure",
                label: "Túlnyomás",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "ionizingRadiation",
                label: "Ionizáló sugárzás",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "ultravioletInfraredOtherNonIonizingRadiation",
                label: "Ultraib., infrav., egyéb nem ionizáló sugárzás",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "biologicalPathogens",
                label: "Biológiai kóroki tényezők",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "specialistPositionForEpidemiologicalInterest",
                label: "Járványügyi érdekből kiemelt munkakör",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "psychosocialFactor",
                label: "Pszichoszociális kóroki tényező",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "ergonomicFactor",
                label: "Ergonómiai kóroki tényező",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "riskOfAccident",
                label: "Baleseti veszély",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "easyPhysicalWork",
                label: "Könnyű fizikai munka",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "moderatelyHardPhysicalWork",
                label: "Közepesen nehéz fizikai munka",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "hardPhysicalWork",
                label: "Nehéz fizikai munka",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "warmExposure",
                label: "Hőexpozíció",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "coldExposure",
                label: "Hideg expozíció",
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "allergicHypersensitivity",
                label: "Allergiás túlérzékenység",
                formVisible: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "currentChronicDiseases",
                label: "Jelenlegi idült betegségek",
                formVisible: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "reportedOccupationalDiseasesIncreasedExposure",
                label: "Bejelentett foglalkozási betegség(ek)",
                formVisible: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "previousMajorDiseasesSurgeriesAccidents",
                label: "Előző lényegesebb betegségek, műtétek, balesetek",
                formVisible: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "takingMedication",
                label: "Gyógyszerszedés",
                formVisible: true,
                formSize: 4,
                formType: "text"
            }
        ]
    }
}